import { renderComponent } from 'utils/commonUtils';
import SsaComponent from './components/SsaComponent';

const Ssa = () => {
  return renderComponent(<SsaComponent />);
};

export default Ssa;
